var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('marker',{staticClass:"workflow__arrowhead",attrs:{"id":_vm.id,"viewBox":"-10 -10 20 20","refX":"1","refY":"0","markerWidth":("" + _vm.width),"markerHeight":("" + _vm.height),"markerUnits":_vm.markerUnits,"orient":_vm.orient}},[(_vm.type === _vm.MarkerType.ArrowClosed)?_c('polyline',{style:({
      stroke: _vm.color,
      fill: _vm.color,
      strokeWidth: _vm.strokeWidth
    }),attrs:{"stroke-linecap":"round","stroke-linejoin":"round","points":"-5,-4 0,0 -5,4 -5,-4"}}):_vm._e(),(_vm.type === _vm.MarkerType.Arrow)?_c('polyline',{style:({
      stroke: _vm.color,
      strokeWidth: _vm.strokeWidth
    }),attrs:{"stroke-linecap":"round","stroke-linejoin":"round","fill":"none","points":"-5,-4 0,0 -5,4"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }